// @flow

import { FormControl } from 'reshaped';
import type { FormControlProps } from 'reshaped';

export type Props = {
  ...FormControlProps,
  fieldState: any,
  label?: React.Node,
  help?: React.Node,
};

export function FieldWrapper({
  children,
  fieldState,
  label,
  help,
  ...extraProps
}: Props): React.MixedElement {
  return (
    <FormControl hasError={fieldState.invalid} size="large" {...extraProps}>
      {label ? <FormControl.Label>{label}</FormControl.Label> : null}

      {children}

      {help ? <FormControl.Helper>{help}</FormControl.Helper> : null}
      {fieldState.error?.message ? (
        <FormControl.Error>{fieldState.error?.message}</FormControl.Error>
      ) : null}
    </FormControl>
  );
}
